export const CLEAR_CHALLENGE = 'CLEAR_CHALLENGE'
export const TOGGLE_CHALLENGE_MODAL = 'TOGGLE_CHALLENGE_MODAL'
export const TOGGLE_CHALLENGE_EXPIRATION_MODAL = 'TOGGLE_CHALLENGE_EXPIRATION_MODAL'
export const TOGGLE_SUMMARY_MODAL = 'TOGGLE_SUMMARY_MODAL'
export const TOGGLE_CHALLENGE_LEI_CODE_MODAL = 'TOGGLE_CHALLENGE_LEI_CODE_MODAL'
export const TOGGLE_CHALLENGE_ADDRESS_MODAL = 'TOGGLE_CHALLENGE_ADDRESS_MODAL'
export const TOGGLE_CHALLENGE_PERIODS = 'TOGGLE_CHALLENGE_PERIODS'
export const TOGGLE_CHALLENGE_RELATIONSHIP_DETAILS_MODAL = 'TOGGLE_CHALLENGE_RELATIONSHIP_DETAILS_MODAL'
export const SAVE_FIELD = 'SAVE_FIELD'
export const RM_FIELD = 'RM_FIELD'
export const RM_FIELDS = 'RM_FIELDS'
export const SET_CHALLENGE = 'SET_CHALLENGE'
export const SET_PARENT_TYPE = 'SET_PARENT_TYPE'
export const SET_SUMMARY = 'SET_SUMMARY'
export const SET_CHALLENGE_ADDRESS = 'SET_CHALLENGE_ADDRESS'
export const SET_CURRENT_RELATIONSHIP_TYPE = 'SET_CURRENT_RELATIONSHIP_TYPE'
export const SET_CHALLENGE_PERIODS = 'SET_CHALLENGE_PERIODS'
export const SET_RELATIONSHIP_DETAILS = 'SET_RELATIONSHIP_DETAILS'
export const TOGGLE_CHALLENGE_RELATIONSHIP_MODAL = 'TOGGLE_CHALLENGE_RELATIONSHIP_MODAL'



// WEBPACK FOOTER //
// ./src/store/modules/record/modules/challenge/mutations-types.js